import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { BrazeContext } from './BrazeProvider';
const ContentCardContext = createContext({
    status: 'waiting',
    cards: [],
});
const useContentCards = () => {
    const contentCardState = useContext(ContentCardContext);
    if (contentCardState === null) {
        throw new Error('useContentCards must be used within a BrazeProvider tag');
    }
    const { trackingLibrary } = useContext(BrazeContext);
    return { ...contentCardState, tracking: trackingLibrary };
};
const ContentCardProvider = ({ children, contentCardState }) => {
    return (_jsx(ContentCardContext.Provider, { value: contentCardState, children: children }));
};
export { useContentCards, ContentCardProvider, ContentCardContext, };
//# sourceMappingURL=ContentCardProvider.js.map